<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow" width="707px" style="padding:0">

    <div ref="mainContent">
      <table class="table-order-detail" style="transform:scale(1);transform-origin: top center;">
        <!-- 92 188 58 111 111 -->
        <tr>
          <td colspan="5" style="height: 37px;text-align: center;border:none;">
            <img height="25" src="@/assets/img/logo-order-export.png" onload="window.print()"/>
          </td>
        </tr>
        <tr>
          <td>訂單號碼</td>
          <td colspan="4">{{oriObj | getOrderID}}</td>
        </tr>
        <tr>
          <td>收件人</td>
          <td colspan="2">{{oriObj.IsPickByCustomerSelf ? '自取' : oriObj.ReceiverInfo.Name}}</td>
          <td colspan="2">訂貨人: {{oriObj.BuyerInfo.Name}}</td>
        </tr>
        <tr>
          <td>收件人電話</td>
          <td colspan="2">{{oriObj.IsPickByCustomerSelf ? '' : oriObj.ReceiverInfo.Phone}}</td>
          <td colspan="2">訂貨人電話: {{oriObj.BuyerInfo.Phone}}</td>
        </tr>
        <tr>
          <td>收件人地址</td>
          <td colspan="4">{{oriObj.IsPickByCustomerSelf ? '' : `${oriObj.ReceiverInfo.PostalCode}${oriObj.ReceiverInfo.County}${oriObj.ReceiverInfo.Township}${oriObj.ReceiverInfo.Village}${oriObj.ReceiverInfo.Detail}`}}</td>
        </tr>
        <tr>
          <td>配送時段</td>
          <td colspan="4">{{oriObj.DeliveryTime}}
            <span v-if="oriObj.IsCallWhileArrived"> (貨到電聯) </span>
            <span v-if="oriObj.IsGift"> (送禮用) </span>
          </td>
        </tr>
        <tr>
          <td colspan="5" style="height: 35px; vertical-align: top; padding-top: 5px;">訂單備註:
            <span v-html="oriObj.Remark.replaceAll('\n', '<br>')"></span>
          </td>
        </tr>
        <!-- <tr>
          <td>其他備註:</td>
          <td colspan="4">{{oriObj.AdminRemark}}</td>
        </tr> -->
        <tr>
          <td style="text-align: center;" colspan="2">商品</td>
          <td style="text-align: center;">數量</td>
          <td style="text-align: center;">價格</td>
          <td style="text-align: center;">小計</td>
        </tr>
        <!-- <tr v-for="index in 5" :key="index">
          <td colspan="2">{{oriObj.OrderProducts.length >= index ? oriObj.OrderProducts[index-1].Product.Tw.Name : ''}}</td>
          <td style="text-align: center;">{{oriObj.OrderProducts.length >= index ? oriObj.OrderProducts[index-1].Amount : ''}}</td>
          <td style="text-align: right;">
            <span v-show="oriObj.OrderProducts.length >= index">$</span>
            {{oriObj.OrderProducts.length >= index ? oriObj.OrderProducts[index-1].Price : ''}}
          </td>
          <td style="text-align: right;">
            <span v-show="oriObj.OrderProducts.length >= index">$</span>
            {{oriObj.OrderProducts.length >= index ? oriObj.OrderProducts[index-1].Price*oriObj.OrderProducts[index-1].Amount : ''}}
          </td>
        </tr> -->
        <!-- 若超過5個？ -->
        <!-- 先抓一般商品-->
        <tr v-for="(orderProduct, idx) in oriObj.OrderProducts.filter(o=>o.Product.ProductType == 0)" :key="`order-detail-product-${idx}`">
          <td colspan="2">{{orderProduct.Product.Tw.Name}}</td>
          <td style="text-align: center;">{{orderProduct.Amount}}</td>
          <td style="text-align: right;">
            <span>$</span>
            {{orderProduct.Price}}
          </td>
          <td style="text-align: right;">
            <span>$</span>
            {{orderProduct.Price*orderProduct.Amount}}
          </td>
        </tr>
        <!-- 抓出贈品 -->
        <tr v-for="(orderGift, idx) in oriObj.OrderGifts" :key="`order-detail-gift-${idx}`">
          <td colspan="2">贈品：{{orderGift.Gift.NameTw}}</td>
          <td style="text-align: center;">{{orderGift.Amount}}</td>
          <td style="text-align: right;">
            <span>$</span>
            0
          </td>
          <td style="text-align: right;">
            <span>$</span>
            0
          </td>
        </tr>
        <!-- 抓出折扣碼 -->
        <tr v-if="coupon" :key="`order-coupon`">
          <td colspan="2">折扣碼：{{ couponName}}</td>
          <td style="text-align: center;">0</td>
          <td style="text-align: right;">
            <span>-$</span>
            {{oriObj.CouponDiscount}}
          </td>
          <td style="text-align: right;">
            <span>-$</span>
            {{oriObj.CouponDiscount}}
          </td>
        </tr>

        <!-- 抓出加價購 -->
        <tr v-if="oriObj.OrderProducts.filter(o=>o.Product.ProductType == 1).length > 0" :key="`order-detail-additional-product-title`">
          <td colspan="2" style="text-align:center;">加價購</td>
          <td style="text-align: center;"></td>
          <td style="text-align: right;"></td>
          <td style="text-align: right;"></td>
        </tr>
        <tr v-for="(orderProduct, idx) in oriObj.OrderProducts.filter(o=>o.Product.ProductType == 1)" :key="`order-detail-additional-product-${idx}`">
          <td colspan="2">加價購：{{orderProduct.Product.Tw.Name}}</td>
          <td style="text-align: center;">{{orderProduct.Amount}}</td>
          <td style="text-align: right;">
            <span>$</span>
            {{orderProduct.Price}}
          </td>
          <td style="text-align: right;">
            <span>$</span>
            {{orderProduct.Price*orderProduct.Amount}}
          </td>
        </tr>

        <!-- 結尾加入空白行，最多五筆-->
        <tr v-for="index in emptyRowCount" :key="`empty-index`">
          <td colspan="2"></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr>
          <td colspan="2">小計</td>
          <td style="text-align: center;">{{oriObj.OrderProducts.reduce((sum, o)=>o.Amount+sum, 0) + oriObj.OrderGifts.reduce((sum, o)=>o.Amount+sum, 0)}}</td>
          <td style="text-align: right;">
            <span>$</span>
            {{oriObj.OrderProducts.reduce((sum, o)=>o.Price+sum, 0) - oriObj.CouponDiscount}}
          </td>
          <td style="text-align: right;">
            <span>$</span>
            {{oriObj.OrderProducts.reduce((sum, o)=>o.Amount*o.Price+sum, 0) - oriObj.CouponDiscount}}
          </td>
        </tr>
        <tr>
          <td style="width:92px;"><span>購物金:</span>  <span style="float: unset;">$ {{oriObj.UsedVoucherAmount | amountFormat}}</span></td>
          <td style="width:188px;"><span>運費:</span>    <span style="float: unset;">$ {{oriObj.ShippingCost | amountFormat}}</span></td>
          <td style="width:58px;"></td>
          <td style="width:111px;text-align: right;">總金額</td>
          <td style="width:111px;text-align: right;">
            <span>$</span>
            {{oriObj.PaidAmount | amountFormat}}
          </td>
        </tr>
        <tr>
          <td colspan="2">付款方式: {{oriObj.PaymentMethod}}</td>
          <td style="text-align: center">抬頭</td>
          <td colspan="2">{{oriObj.ReceiptPaperCompanyTitle}}</td>
        </tr>
        <tr>
          <td colspan="2">發票類型: {{oriObj.ReceiptType}}</td>
          <td style="text-align: center">統編</td>
          <td colspan="2">{{oriObj.ReceiptType == '紙本發票' ? oriObj.ReceiptPaperTaxID : oriObj.ReceiptDigitalTaxID}}</td>
        </tr>
      </table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="print">列印</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
// svgs
import '@/assets/svgs/index.js'
export default {
  mixins: [MixinFilters, MixinProcessImageFile, MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    title () {
      return '訂單列印'
    },
    couponName() {
      try {
        if (this.oriObj && this.oriObj.CouponLog && this.oriObj.CouponLog.CouponJSON) {
          let coupon = JSON.parse(this.oriObj.CouponLog.CouponJSON)
          return coupon.NameTw
        }
      } catch(ignored) {}
      return this.coupon.NameTw 
    },
    coupon() {
      if (!this.oriObj.CouponID) return null
      return this.$store.state.coupon.list.list.find(o=>o.ID==this.oriObj.CouponID)
    },
    emptyRowCount () {
      let rowCount = this.oriObj.OrderProducts.length + this.oriObj.OrderGifts.length
      if (this.coupon) rowCount += 1
      if (this.oriObj.OrderProducts.filter(o=>o.Product.ProductType==1).length) rowCount += 1//加價購多一行標題
      if (rowCount >= 5) return 0
      return 5-rowCount
    }
  },
  methods: {
    print () {
      var height = 450 + 70
      let printWindow = window.open('', '' + (new Date().getTime()), 'width=707,height='+height)
      let html = this.$refs.mainContent.outerHTML
      let style = `
<style>
.table-order-detail{
  transform: scale(1.2) !important;
  font-size: 12px;
  color: #000;
  border-spacing: 0;
  width: 560px;
  margin: 0 auto;
}
.table-order-detail td {
  border: 1px solid #000;
  border-spacing: 0;
  vertical-align: middle;
  padding-left: 4px;
  padding-right: 4px;
}
.table-order-detail tr {
  border-spacing: 0;
  height: 20px;
}
</style>
`
      printWindow.document.write(html + style)
      // setTimeout(() => {
      //   printWindow.print()
      // }, 1000)
    },
    close () {
      this.$emit('close')
    }
  },
  created () {
    window.print = () => { console.log('not print...') }
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            IsActive: true
          }
        }
      }
    }
  }
}
</script>

<style>
.table-order-detail{
  font-size: 12px;
  color: #000;
  border-spacing: 0;
  /* border: 1px solid #000; */
  width: 560px;
  margin: 0 auto;
}
.table-order-detail td {
  border: 1px solid #000;
  border-spacing: 0;
  vertical-align: middle;
  padding-left: 4px;
  padding-right: 4px;
}
.table-order-detail tr {
  border-spacing: 0;
  height: 20px;
}
</style>
